<template>
  <div>
    <navbar back fixed bg>
      <span slot="title">注册协议</span>
    </navbar>
    <div class="page-content">
      <scroller ref="scroller">
        <div style="position:relative;z-index:30">
          <div style="position:absolute;width:100%;left:0;top:0;height:100%;z-index:20"></div>
          <iframe src="/xieyi/yh.jsp" frameborder="0" scrolling="no" style="position:relative;width:100%;height:100%;z-index:10" ref="iframe"></iframe>
        </div>
      </scroller>
    </div>
  </div>
</template>

<script>
  import Navbar from 'components/navbar/navbar'
  import Scroller from 'components/scroller/scroller'

  export default {
    data () {
      return {
        loaded: false
      }
    },
    components: {
      Navbar,
      Scroller
    },
    watch: {
      loaded: '_refresh'
    },
    mounted () {
      this.iframe = this.$refs.iframe
      this.iframe.addEventListener('load', () => {
        this.loaded = true
      })
      this._resize()
    },
    methods: {
      _refresh () {
        if (this.loaded) {
          let doc = this.iframe.contentDocument
          let height = doc.body.offsetHeight
          this.iframe.style.height = height + 10 + 'px'
          this._resize()
        }
      },
      _resize () {
        this.$nextTick(() => {
          if (this.$refs.scroller) {
            setTimeout(() => {
              this.$refs.scroller.resize()
            }, 500)
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// protocol.vue?1f467cd9